const MAX_DISPLAY_FILENAME_LENGTH = 180;
const PROVIDER_TOKEN_PATTERN = /(?:^|[^a-z0-9])(?:fbcdn|lookaside|scontent|fbsbx)(?:[^a-z0-9]|$)|cdn\.fb|\boh=|\boe=/i;
const URL_PATTERN = /^(?:https?:\/\/|www\.)/i;
const HEX_OR_ID_PATTERN = /^(?:[0-9a-f]{16,}|[0-9]{10,})$/i;
/**
 * True when a provider-supplied name is safe to show as the original filename.
 * Download fallbacks may still use a generated `document.pdf`-style name.
 */
export function isDisplayableOriginalFilename(fileName) {
    return toDisplayableOriginalFilename(fileName) != null;
}
export function toDisplayableOriginalFilename(fileName) {
    if (typeof fileName !== "string") {
        return null;
    }
    const trimmed = fileName.trim();
    if (trimmed.length === 0 || trimmed.length > MAX_DISPLAY_FILENAME_LENGTH) {
        return null;
    }
    if (/[\u0000-\u001f\u007f]/.test(trimmed)) {
        return null;
    }
    if (URL_PATTERN.test(trimmed) || trimmed.includes("://")) {
        return null;
    }
    if (PROVIDER_TOKEN_PATTERN.test(trimmed)) {
        return null;
    }
    const stem = trimmed.includes(".") ? trimmed.slice(0, trimmed.lastIndexOf(".")) : trimmed;
    const identity = stem.length > 0 ? stem : trimmed;
    if (HEX_OR_ID_PATTERN.test(identity.replace(/[-_]/g, ""))) {
        return null;
    }
    const letters = trimmed.match(/\p{L}/gu)?.length ?? 0;
    if (letters === 0) {
        return null;
    }
    const meaningful = trimmed.match(/[\p{L}\p{N}]/gu)?.length ?? 0;
    if (meaningful / trimmed.length < 0.35) {
        return null;
    }
    return trimmed;
}
//# sourceMappingURL=display-filename.js.map